import { z } from 'zod'

import { DateStringSchema, type ZodInfer } from '@mntn-dev/utility-types'

export const CreditTransferSchema = z.object({
  transferredCredits: z.number(),
  sourceBalance: z.number(),
  destinationBalance: z.number(),
  expirationDate: DateStringSchema,
})

export type CreditTransfer = ZodInfer<typeof CreditTransferSchema>
